<div class="common-drop-down common-drop-down-arrow"
     [className]="validate && isValidated(selectedItemId) ? 'invalid-drop-down-input' : 'drop-down-input'">
    <span class="name">{{name}}</span>
    <ng-select [clearable]="false" [searchable]="searchable" (blur)="onSaveModelDropDown()" (focus)="onSaveState()" [(ngModel)]="selectedItemId"
               class="custom" (change)="onSelectedItemIdChange()" [disabled]="!!disabled">
        <ng-option *ngFor="let item of items" [value]="item.id">{{item.name}}</ng-option>
    </ng-select>
</div>
